/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
 */

// Vendor Requires
require('./vendor/picturefill.min.js');
require('./vendor/jquery-ui-custom.min'); // (required for coverflow - backup downloader: https://jqueryui.templersmc.net/download/#!version=1.12.1&components=100010000010000000000000000000000000000000000000)
require('./vendor/slick.min');
require('./vendor/jquery.coverflow');
require('./vendor/jquery.touchSwipe.min');
require('./vendor/jquery.zoom.min');
require('./vendor/jquery.fitvids.js');
require('./vendor/imagesloaded.pkgd.min.js');
require('./vendor/iframeResizer.min.js');
require('./vendor/popper.min.js');
require('./vendor/bootstrap-tooltip.js');

// App Requires
require('./app/config');
require('./app/helpers');
require('./app/global');
require('./app/collection');
require('./app/product');
require('./app/cart');
require('./app/customers');
require('./app/collapse');
require('./app/accordion');
require('./app/locator');
require('./app/tabs');
require('./app/product-explorer');
require('./app/search');
require('./app/sliders'); // keep this after product js for pre-selecting media
